// src/components/GoogleSSO.js
import React from 'react';
import { googleConfig, googleScopes, googleApiConfig } from '../config/googleConfig';

const GoogleSSO = ({ onLoginSuccess, onLoginError }) => {
    const handleGoogleLogin = async () => {
        try {
            // Create Google OAuth URL
            const params = new URLSearchParams({
                client_id: googleConfig.clientId,
                redirect_uri: googleConfig.redirectUri,
                scope: googleScopes.join(' '),
                response_type: googleConfig.responseType,
                access_type: googleConfig.accessType,
                prompt: googleConfig.prompt,
                state: Math.random().toString(36).substring(7) // CSRF protection
            });

            const authUrl = `${googleApiConfig.authEndpoint}?${params.toString()}`;

            // Open Google OAuth popup
            const popup = window.open(
                authUrl,
                'googleAuth',
                'width=500,height=600,scrollbars=yes,resizable=yes'
            );

            // Listen for the popup to close or receive message
            const checkClosed = setInterval(() => {
                if (popup.closed) {
                    clearInterval(checkClosed);
                    onLoginError && onLoginError(new Error('Authentication cancelled'));
                }
            }, 1000);

            // Listen for messages from popup
            const messageListener = (event) => {
                if (event.origin !== window.location.origin) return;

                if (event.data.type === 'GOOGLE_AUTH_SUCCESS') {
                    clearInterval(checkClosed);
                    window.removeEventListener('message', messageListener);
                    popup.close();

                    const userInfo = {
                        id: event.data.user.id,
                        email: event.data.user.email,
                        name: event.data.user.name,
                        picture: event.data.user.picture,
                        accessToken: event.data.accessToken,
                        idToken: event.data.idToken,
                    };

                    onLoginSuccess && onLoginSuccess(userInfo);
                } else if (event.data.type === 'GOOGLE_AUTH_ERROR') {
                    clearInterval(checkClosed);
                    window.removeEventListener('message', messageListener);
                    popup.close();
                    onLoginError && onLoginError(new Error(event.data.error));
                }
            };

            window.addEventListener('message', messageListener);

        } catch (error) {
            console.error('Google SSO login failed:', error);
            onLoginError && onLoginError(error);
        }
    };

    return (
        <button
            type="button"
            onClick={handleGoogleLogin}
            className="w-100 sso-button google-button"
            style={{
                width: '100%',
                height: '36px',
                fontSize: '0.95rem',
                fontWeight: 600,
                borderRadius: '8px',
                border: '1px solid #e5e7eb',
                color: '#36454f',
                textTransform: 'none',
                letterSpacing: '0.3px',
                backgroundColor: '#ffffff',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '12px',
                transition: 'all 0.3s ease',
            }}
            onMouseEnter={(e) => {
                e.target.style.borderColor = '#d1d5db';
                e.target.style.backgroundColor = '#f9fafb';
                e.target.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={(e) => {
                e.target.style.borderColor = '#e5e7eb';
                e.target.style.backgroundColor = '#ffffff';
                e.target.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.05)';
            }}
        >
            <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Sign in with Google
        </button>
    );
};

export default GoogleSSO;